'use strict';
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useLoading } from '@/contexts/LoadingContext';
import { useLogout } from '@/contexts/LogoutContext';

/**
 * Global loading component that shows a single spinner
 * when any component is in a loading state
 */
export const GlobalLoading = ({ showEulaModal }) => {
	const { isLoading } = useLoading();
	const { isLoggingOut } = useLogout();

	// Don't show if EULA modal is active (it has its own loading state)
	if (!isLoading || showEulaModal || isLoggingOut) {
		return null;
	}

	return (
		<Box
			sx={{
				position: 'fixed',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				width: '100vw',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				backgroundColor: 'white',
				zIndex: 9999,
				pointerEvents: 'none' // Allow clicks to pass through when not actively blocking
			}}
		>
			<CircularProgress size={40} />
		</Box>
	);
};

export default GlobalLoading;

